export const environment = {
  production: true,
  development: false,
  test: false,
  brand: 'VYV',
  apiConfig: {
    scopes: ['api://boiard-tst-02-back-office/Read.All', 'api://boiard-tst-02-back-office/Write.All'],
    uri: 'https://tst-02.assurance.vyv-conseil.fr/api/',
  },
  keycloak: {
    url: 'https://rec.authentification.harmonie-mutuelle.fr/auth',
    realm: 'adherents_rec3',
    clientId: 'vyvconseil_rec3',
    tokenEndpoint: 'authentication/token/hm',
  },
  passConnect: {
    url: 'https://passconnect-preprod.groupe-vyv.fr/auth',
    realm: 'passconnect',
    clientId: 'sequoia-adherent-test',
    tokenEndpoint: 'authentication/token/passconnect',
  },
  appInsightsConfig: {
    connectionString: 'InstrumentationKey=ab0508f5-e01f-4f79-8db0-5f7c95fd83a4;IngestionEndpoint=https://francecentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://francecentral.livediagnostics.monitor.azure.com/;ApplicationId=e747e458-a708-4ad9-b80a-ee37b256d4be',
    maxBatchIntervalMs: '15000',
  },
  ParcoursDeSouscription: {
    AHC: 'https://tst-02.assurance-habitation.vyv-conseil.fr/product/HC',
    AHP: 'https://tst-02.assurance-habitation.vyv-conseil.fr/product/HP',
    AHS: 'https://tst-02.assurance-habitation.vyv-conseil.fr/product/HS',
    AHT: 'https://tst-02.assurance-habitation.vyv-conseil.fr/product/HT',
  },
  EspaceAdherentUrl: {
    MGEN: "https://www.mgen.fr/login-adherent/",
    HM: "https://harmonie-et-moi.fr/",
    MNT: "https://adherents.mnt.fr/"
  },
  Systempay: {
    endpoint: 'https://api.systempay.fr',
    publicKey: '73852400:testpublickey_HbYVxnyDUy7eCiCL0OK9l8b8PJRG6suXyVpxzdsM1v6cv',
  },
   msalConfig: {
    auth: {
      clientId: '1c202886-5e2c-4e20-a4a9-4301f0508cc1',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
    },
    enabled: 'true',
  },
};
